import { render, staticRenderFns } from "./PageFieldsRestore.vue?vue&type=template&id=4909b902&scoped=true&"
import script from "./PageFieldsRestore.vue?vue&type=script&lang=js&"
export * from "./PageFieldsRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4909b902",
  null
  
)

export default component.exports